import React, { Component } from 'react';
import PropTypes from 'prop-types';
import QuestionMark from 'components/QuestionMark';
import i18n from 'utils/translate';
import { isEmail } from 'validator';
import { numbersOnly, noNumbers, startWithNumber, numberTwelveDigits } from 'utils/validators';
import AutoNumeric from 'autonumeric';

import './styles.scss';
import Datepicker from 'components/Datepicker';

const propTypes = {
  className: PropTypes.string,
  date: PropTypes.bool,
  help: PropTypes.string,
  iban: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.string,
  max: PropTypes.number,
  maxDate: PropTypes.object,
  maxLength: PropTypes.number,
  min: PropTypes.number,
  minDate: PropTypes.object,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onWrongDate: PropTypes.func,
  pattern: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  questionMark: PropTypes.string,
  questionMarkImage: PropTypes.string,
  disabled: PropTypes.bool,
  textArea: PropTypes.bool,
  currencyInput: PropTypes.bool,
  type: PropTypes.oneOf(['email', 'number', 'tel', 'text']).isRequired,
  value: PropTypes.any,
  customError: PropTypes.any
};

const defaultProps = {
  required: false,
  type: 'text',
  value: '',
  className: '',
  disabled: false,
  textArea: false,
  currencyInput: false
};

class TextField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requiredError: false,
      numberError: false,
      startWithNumberError: false,
      numberTwelveDigitsError: false,
      negativeCurrencyError: false,
      minNumberError: false,
      charError: false,
      emailError: false,
      dateError: false,
      IsDirty: false
    };
  }

  autonumeric;

  static getDerivedStateFromProps(nextProps, prevState) {
    const { value, required } = nextProps;
    const { requiredError, isDirty } = prevState;

    // We need to reset requiredError for resolved values
    if (value && required && requiredError) {
      return { requiredError: false };
    }
    // We only trigger errors after onBlur happened
    if (!isDirty) {
      return { requiredError: false, customError: false };
    }
    return null;
  }

  componentDidMount() {
    if (navigator && navigator.appVersion && navigator.appVersion.indexOf('MSIE 10') !== -1) {
      //IE10
    } else {
      if (this.refs.currency) {
        this.autonumeric = new AutoNumeric(this.refs.currency, {
          decimalCharacter: ',',
          digitGroupSeparator: '.',
          modifyValueOnWheel: false,
          minimumValue: 0
        });
      }
    }
  }

  onChange = newValue => {
    const { onChange } = this.props;

    let value = newValue.target.value;

    if (onChange) {
      onChange(value);
    }
  };

  onBlur = () => {
    const { pattern, value, required, type, onBlur, min } = this.props;
    const { isDirty } = this.state;

    if (onBlur) {
      onBlur();
    }

    console.log('HERE1');

    if (!isDirty) {
      this.setState({ isDirty: true });
    }
    console.log('HERE2');

    if (!value) {
      this.setState({
        charError: false,
        emailError: false,
        requiredError: required,
        numberError: false,
        numberTwelveDigitsError: false,
        dateError: false,
        startWithNumberError: false,
        customError: false
      });

      return;
    } else {
      this.setState({
        requiredError: false
      });
    }

    console.log('HERE3');

    if (type === 'email') {
      this.setState({ emailError: !isEmail(value) });
      return;
    }

    if (this.refs.currency) {
      this.setState({ negativeCurrencyError: this.autonumeric.getNumber() <= 0 });

      if (min) {
        this.setState({ minNumberError: this.autonumeric.getNumber() < min });
      }
      return;
    }

    const reg = new RegExp(pattern);

    if (pattern === numbersOnly) {
      this.setState({
        charError: !reg.test(value)
      });
    } else if (pattern === numberTwelveDigits) {
      this.setState({
        numberTwelveDigitsError: !reg.test(value)
      });
    } else if (pattern === noNumbers) {
      this.setState({
        numberError: !reg.test(value)
      });
    } else if (pattern === startWithNumber) {
      this.setState({
        startWithNumberError: !reg.test(value)
      });
    }
  };

  onChangeDate = value => {
    const { onChange } = this.props;

    if (onChange) {
      onChange(value);
    }
  };

  getErrorResponse = () => {
    const { customError } = this.props;
    const {
      emailError,
      charError,
      numberError,
      dateError,
      requiredError,
      startWithNumberError,
      numberTwelveDigitsError,
      negativeCurrencyError,
      minNumberError
    } = this.state;
    let error;

    if (customError) {
      error = customError;
    } else if (requiredError) {
      error = 'Eingabe erforderlich!';
    } else if (negativeCurrencyError) {
      error = 'Eingabe erforderlich!';
    } else if (emailError) {
      error = 'Eingabewert ist keine Emailadresse!';
    } else if (charError) {
      error = 'Nur Eingabe von Zahlen erlaubt!';
    } else if (numberError) {
      error = 'Eingabe darf keine Zahlen enthalten!';
    } else if (numberTwelveDigitsError) {
      error = 'Eingabe muss eine Zahl mit 12 Stellen sein!';
    } else if (dateError) {
      error = 'Eingabe kein gültiges Datum';
    } else if (startWithNumberError) {
      error = 'Erstes Zeichen muss eine Zahl sein!';
    } else if (minNumberError) {
      error = `Eingabe muss mindestens ${300} sein!`;
    }

    return <span className="field-error-message">{i18n(error)}</span>;
  };

  render() {
    const {
      emailError,
      charError,
      numberError,
      dateError,
      requiredError,
      startWithNumberError,
      numberTwelveDigitsError,
      negativeCurrencyError
    } = this.state;
    const {
      label,
      value,
      type,
      min,
      minDate,
      placeholder,
      max,
      maxDate,
      required,
      maxLength,
      id,
      pattern,
      className,
      date,
      questionMark,
      questionMarkImage,
      disabled,
      textArea,
      currencyInput,
      name,
      customError,
      onWrongDate,
      dateFormat
    } = this.props;
    const inputProps = { type, min, max, required, placeholder, maxLength, id, pattern, disabled, name };
    const inputDateProps = { minDate, maxDate, placeholder, required, value, dateFormat };
    inputProps.value = value ? value : '';
    inputDateProps.value = value ? value : undefined;

    const isError =
      charError ||
      emailError ||
      requiredError ||
      numberError ||
      dateError ||
      startWithNumberError ||
      numberTwelveDigitsError ||
      negativeCurrencyError ||
      customError;

    let input;
    let tooltip;

    if (textArea) {
      input = <textarea className="responsive-field__textarea" {...inputProps} onChange={this.onChange}></textarea>;
    } else if (date) {
      input = (
        <Datepicker
          className={`responsive-field__datepicker ${isError ? 'textfield-error ' : ''}`}
          {...inputDateProps}
          onChange={this.onChangeDate}
          onWrongDate={wrongValue => (onWrongDate ? onWrongDate(wrongValue) : null)}
          onBlur={() => setTimeout(this.onBlur)}
        />
      );
    } else if (currencyInput) {
      input = (
        <input
          {...inputProps}
          onChange={this.onChange}
          onBlur={this.onBlur}
          className={`responsive-field__input ${isError ? 'textfield-error ' : ''}`}
          ref="currency"
        />
      );
    } else {
      input = (
        <input
          className={`responsive-field__input ${isError ? 'textfield-error ' : ''}`}
          {...inputProps}
          onChange={this.onChange}
          onBlur={this.onBlur}
        />
      );
    }

    if (questionMark) {
      tooltip = <QuestionMark content={questionMark} />;
    } else if (questionMarkImage) {
      tooltip = <QuestionMark image={questionMarkImage} />;
    }

    return (
      <div className={`responsive-field ${className} textfield-wrapper ${isError ? 'textfield-error ' : ''}`}>
        <label className="responsive-field__label" htmlFor={id}>
          {label} {tooltip}
        </label>
        <div className="input-wrapper">
          {input}
          <div className="error-sign" />
        </div>
        {this.getErrorResponse()}
      </div>
    );
  }
}

TextField.propTypes = propTypes;
TextField.defaultProps = defaultProps;

export default TextField;
